import { formSkeletonConfig } from "../forms/formSkeleton";
import { FormSkeletonStyle } from "../forms/style";

export function getClassName<style>(
  options: { style?: style; },
  className: keyof style,
  notset: string = ""
): string {
  return String(options && options.style && options.style[className] ? options.style[className] : notset);
}

export function getClassNameModern<style>(
  options: style | undefined,
  className: keyof style,
  notset: string = ""
): string {
  return String(options && options[className] ? options[className] : notset);
}

export function getFSClassName(
  className: keyof FormSkeletonStyle,
  bootstrapClassName: string = '',
): string {
  return getClassName({ style: formSkeletonConfig.options.style }, className, bootstrapClassName)
}
